export default __webpack_public_path__ + "static/media/ic_home_active_cake.2adf1556.svg";